// extracted by mini-css-extract-plugin
export var active = "_wv-1";
export var container = "_wv-0";
export var icon = "_wv-2";